export default {"src":"/uk/_next/static/media/pension-confident-podcast-logo.88a16167.svg","height":150,"width":150,"blurWidth":0,"blurHeight":0};